import type React from 'react';

import { colors } from '@change/ds-tokens';

// Global CSS targeting HugeRTE's third-party `.tox-*` classes (no Tailwind hook available,
// and we no longer use emotion/theme-ui). Injected via a plain <style> element.
// The body font uses the design-system sans var; remaining values are literals.
const STYLES = `
body .tox-hugerte { border-radius: 8px; }
html:not(.dark) body .tox-hugerte { border-color: #766F81; }
html:not(.dark) body .tox .tox-edit-area::before { border-color: #4771FF; }
html.dark body .tox .tox-edit-area::before { border-color: #a5b9ff; }
body .tox * { font-family: var(--font-sans) !important; }
html:not(.dark) body .tox * { color: #403A49 !important; }
body .tox .tox-tooltip__body { color: #fff !important; }
html.dark body .tox-dialog .tox-label { color: ${colors.semantic.dark.typography.weak} !important; }
body .tox [class="tox-button"] {
	background-image: linear-gradient(90deg, #ffdb00 0%, #ffe600 100%);
	border: none;
	border-radius: 8px;
	color: #403A49;
	font-size: 14px;
	font-weight: bold;
	line-height: 24px;
}
body .tox [class="tox-button"]:hover:not(:disabled) {
	background-image: linear-gradient(90deg, #ffb64d 0%, #ffe600 100%);
	color: #403A49;
}
body .tox [class="tox-button"]:active:not(:disabled) {
	background-image: linear-gradient(90deg, #fe9311 0%, #ffdb00 100%);
	color: #403A49;
}
html:not(.dark) body .tox .tox-button.tox-button--secondary {
	background: #FFFFFF;
	border-color: #918A9D;
	border-radius: 8px;
	border-style: solid;
	border-width: 1px;
	color: #403A49;
	font-size: 14px;
	font-weight: bold;
	line-height: 24px;
}
html.dark body .tox .tox-button.tox-button--secondary {
	border-radius: 8px;
}
html:not(.dark) body .tox .tox-button.tox-button--secondary:hover:not(:disabled) {
	background-color: #403A490D;
	border-color: #918A9D;
}
html:not(.dark) body .tox .tox-button.tox-button--secondary:active:not(:disabled) {
	background-color: #403A491A;
	border-color: #918A9D;
}
body .tox .tox-dialog__body-nav { display: none; }
body .tox .tox-notifications-container { display: none; }
`;

export const GlobalStyle: React.FC = () => {
	// eslint-disable-next-line react/no-danger
	return <style dangerouslySetInnerHTML={{ __html: STYLES }} />;
};
